<template>
  <div class="py-3">
    <div v-if="!isFinal" class="d-flex justify-content-between">
      <a class="h5" href="javascript:void(0)"
        @click="onClick('onCloseModal', 'modeSelect')"
      >
        <i class="uil-arrow-left" style="font-size: 20px;"></i> 
        Apply with Existing {{moduleName}} 
      </a>
      <b-button class="candidate-button button-white" size="sm" @click="onCLickNew">
        New {{moduleName}}
      </b-button>
    </div>
    <div v-else class="d-flex justify-content-start">
      <h5 class="ml-3" >Submitted Successfully</h5>
    </div>
    <label class="d-inline-flex align-items-start col-md-12 mt-3">
      <b-input-group>
        <b-form-input
          v-model="filter"
          type="search"
          placeholder="Search..."
          class="form-control form-control-md SearchInput"
          @keydown.enter.native="onClick('modeSelect', filter)"
        ></b-form-input>
        <b-input-group-prepend>
          <span class="input-group-text"><i class="uil-search"></i></span>
        </b-input-group-prepend>
      </b-input-group>
    </label>
    <div class="justify-content-start col-md-12 mt-3 p-3 card">
      <div class="text-muted text-center" v-if="!candidates.length">
        No {{moduleName}}(s) available as of the moment, please submit candidate instead.
      </div>
      
      <div v-else class="d-flex flex-row flex-wrap justify-content-start candidate-list overflow-auto" style="height:500px">
        <div
          class="col-md-12 mb-2"
          style="border: 1px solid #666666; padding: 1px; border-color: #E0E0E0;"
          v-for="item in candidates"
          :key="item._id"
        >
          <div class="d-flex justify-content-between pt-2">
            <div class="row col-12">
              <div class="col-1 pr-0 pl-3">
                <input 
                  id="checkbox"
                  type="checkbox"
                  v-model="item.is_checked"
                  style="transform: scale(1.6); margin-top: 35px;"
                />
              </div>
              <div class="col-2 media px-0">
                <Avatar 
                  :data="item" 
                  customClass="avatar-lg rounded" 
                  alt="avatar"
                  customFont="35"
                />
              </div>
              <div class="col-9 text-left" style="color: #4F4F4F;">
                <div class="row justify-content-between">
                  <div>
                    <h6 class="mt-1 mb-0 font-weight-normal">
                      {{ item.current_company }}
                      <!-- <router-link
                        tag="a"
                        to=""
                        @click.native="onViewCompany(item)"
                      >
                        {{item.current_company && item.current_company.name ? item.current_company.name : ' - '}}
                      </router-link> -->
                    </h6>
                    <h5 class="mt-1 mb-1" style="color: #333333;"><strong>{{ item.full_name }}</strong></h5>
                  </div>
                  <div>
                    <div class="text-right">
                      <!-- <h6 class="mt-1 mb-0 font-weight-normal">95% Match</h6> -->
                    </div>
                  </div>
                </div>
                <div class="text-left">
                  <div class="row d-flex justify-content-between full-width pl-0">
                    <div class="col-6 pl-0">
                      <h6 class="pt-0 my-1" style="font-size: 12px">Location: {{ item.country ? item.city + ', ' + item.country : item.city }}</h6>
                      <h6 class="font-weight-normal mt-0" style="font-size: 12px">Experience: {{ item.work_experiences[0] ? item.work_experiences[0].position : 'No Employment' }}</h6>
                    </div>
                    <div class="col-6">
                      <!-- <h6 class="pt-0 my-1" style="font-size: 12px">Specialization : UX Design</h6>
                      <h6 class="font-weight-normal mt-0" style="font-size: 12px">Career Status: Actively looking</h6> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span v-if="limit <= candidates.length" class="d-inline-flex align-items-center text-muted ml-1 mr-3">
          <div class="inputWrapper" style="height: 24px; text-decoration: underline;" @click="onSeeMore">
            SEE MORE
          </div>
        </span>

      </div>
    </div>
    <div class="d-flex justify-content-end">
      <b-button class="candidate-button" style="z-index: 1" size="sm" @click="onSelectCandidate()">
        Submit Application
      </b-button>
    </div>

    <Dialog
      centered
      size="lg"
      ref="viewCandidateCompany"
      hideHeader
      customClass="customDialog"
      title="View Company"
      :component="viewCandidateCompanyComponent"
      :parameters="{ candidateCompany }"
      @onClick="onCloseCompanyDetails"
    />
  </div>
</template>

<script>
import Dialog from '@components/dialogs'
import Avatar from '@components/avatar'

export default {
  components: {
    Dialog,
    Avatar
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    candidates() {
      let parameters = this.parameters || {}
      return parameters.candidates.slice(0, this.limit) || []
    },
    viewCandidateCompanyComponent() {
      return () => import('./viewCandidateCompany.vue')
    },
    moduleName() {
      const isCandidate = !this.role_modules.some(item => item.value == 'job.submit_candidate')
      return isCandidate ? "Application" : "Candidate"
    }
  },
  
  data () {
    return {
      isFinal: false,
      filter:'',
      candidateCompany: {},
      limit: 9
    }
  },
  methods: {
    onSelectCandidate() {
      let selectedCandidates = this.candidates.filter(el => { return el.is_checked == true })

      for(let key in selectedCandidates){
        let selected = selectedCandidates[key]
        this.onClick('onSelectCandidate', selected._id)
      }
    },
    onClick(method, bool) {
      this.$emit('onClick', { method, bool })
    },
    onCLickNew() {
      this.onClick('onCloseModal', 'modeSelect')
      this.onClick('modeUpload', true)
    },
    onViewCompany(model){
      if(model && typeof model.current_company == 'object') {
        this.candidateCompany = model.current_company
      }
      
      this.$refs.viewCandidateCompany.show()
    },
    onCloseCompanyDetails(){
      this.$refs.viewCandidateCompany.hide()
    },
    onSeeMore() {
      this.limit += this.limit
    }
  }
}
</script>
<style lang="scss">
.customDialog > div {
  position: absolute;
  width: 592px !important;
  /* height: 1024px !important; */
  /* left: 848px !important; */
  right: 0px;
  top: 0px;
}

.customDialog > .modal-dialog > .modal-content {
  background: #FFFFFF;
  box-shadow: 2px 4px 24px rgba(0, 0, 0, 0.25);
}

.inputWrapper {
  overflow: hidden;
  position: relative;
  cursor: pointer;
  background-color: transparent;
  color: blue;
}

.inputWrapper:hover {
  background-color: transparent;
}
.inputWrapper.clicked {
  background-color: transparent;
}
.candidate-list{
  overflow: hidden;
  &:hover {
    overflow-y: auto;
  }  
}

.custom-scroll {
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }
  
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }

}
</style>